import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { PlayerSessionService } from '../services/player-session.service';

const MISSION_URL = /\/api\/missions\/(\d+)(?:[/?]|$)/;

// Authentifie les routes joueur avec le jeton de la mission appelee (TD-009).
export const agentTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const missionId = MISSION_URL.exec(req.url)?.[1];
  const token = missionId ? inject(PlayerSessionService).tokenFor(Number(missionId)) : null;

  return next(token ? req.clone({ setHeaders: { 'X-Agent-Token': token } }) : req);
};
